import { useNavigate } from "react-router-dom";
import { AUTH_ROUTES } from "../../features/authentication";
import Icon from "./Icon";
import "../../styles/ai/auth-required-gate.css";

export default function AuthRequiredGate({ pendingQuery = "", redirectTo = "/ai-search" }) {
    const navigate = useNavigate();

    const goTo = (route) => {
        navigate(route, { state: { redirectTo, pendingQuery } });
    };

    return (
        <div className="ogm-gate-wrapper">
            <div className="ogm-gate-card">
                <div className="ogm-gate-icon-ring">
                    <Icon name="sparkle" size={30} className="ogm-gate-icon" />
                </div>

                <h2 className="ogm-gate-title">Sign in to use AI Search</h2>

                {pendingQuery && (
                    <div className="ogm-gate-query-bubble">
                        <span className="ogm-gate-query-label">You asked</span>
                        <span className="ogm-gate-query-text">"{pendingQuery}"</span>
                    </div>
                )}

                <p className="ogm-gate-body">
                    Our AI property advisor is available to registered members.
                    Log in or create a free account to pick up right where you left off.
                </p>

                <div className="ogm-gate-btn-row">
                    <button className="ogm-gate-primary-btn" onClick={() => goTo(AUTH_ROUTES.LOGIN)}>
                        Log In
                    </button>
                    <button className="ogm-gate-secondary-btn" onClick={() => goTo(AUTH_ROUTES.SIGNUP)}>
                        Create Account
                    </button>
                </div>

                <button className="ogm-gate-back-link" onClick={() => navigate("/")}>
                    ← Back to home
                </button>
            </div>
        </div>
    );
}
